<meta name="viewport" content="width=device-width, initial-scale=1.0">
<div id="wrapper" class="health-examiner">
    <div class="content-header">
        <div class="content-top"></div>
        <div class="wrapper-reponsive">
            <nav class="navbar header-nav p-0">
                <a href="" class="navbar-brand">
                    <img src="../../../../assets/img/logo.png" alt="">
                </a>
                <div class="navbar-right">
                    <div class="navbar-menu">
                        <ul>
                            <li>
                                <a href="">トップページ</a>
                            </li>
                            <li>
                                <a href="">利用者情報管理</a>
                            </li>
                            <li>
                                <a href="" class="btn-action-log">
                                    <img src="assets/img/icon_login_user .png" alt="">
                                    ログアウト
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="language">
                        <nav class="navbar p-0" aria-label="Dropdown Language">
                            <div class="dropdown">
                                <button class="btn btn-language dropdown-toggle" type="button" id="dropdownLanguageButton"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <img class="img-language" src="assets/img/icon-ja.png" alt="">
                                </button>
                                <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownLanguageButton">
                                    <a class="dropdown-item"><img class="img-language" src="assets/img/icon-ja.png" alt=""> 日本語</a>
                                    <a class="dropdown-item"><img class="img-language" src="assets/img/icon-en.png" alt=""> English</a>
                                    <a class="dropdown-item"><img class="img-language" src="assets/img/icon-vi.png" alt=""> Tiếng Việt</a>
                                </ul>
                            </div>
                        </nav>
                    </div>
                    <button class="btn-toggle-menu">
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>
            </nav>
        </div>
    </div>
    <div class="scrollbar pl-4 pr-4" style="max-height: 100%;">
        <div class="row">
            <div class="wrapper-reponsive">
                <!-- Start màn 1  -->
                <div class="content-box p-4 mt-3">
                    <div class="logo-login">
                        <img src="../../../../assets/img/smarttohmas.png" alt="">
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-4">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">メールアドレス</div>
                            <input type="text" class="form-control mb-3">
                            <div class="tlt-dot mb-1">パスワード</div>
                            <input type="text" class="form-control mb-3">
                            <a href="#">
                                <strong>パスワード忘れはこちら</strong>
                            </a>
                        </div>
                    </div>
                    <div class="pl-4 mb-4">
                        <div class="pl-3">
                            <label class="custom-checkbox">
                                ログイン状態を保持する
                                <input type="checkbox">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                    <div class="text-center">
                        <div class="mb-4">
                            <button class="btn btn-common btn-bg-green">
                                ログイン
                            </button>
                        </div>
                        <div>
                            <button class="btn btn-common btn-bg-yellow">
                                新規登録はこちら
                            </button>
                        </div>
                    </div>
                </div>
                <!-- End màn 1 -->
            </div>
        
            <div class="wrapper-reponsive">
                <!-- Start màn 2 -->
                <div class="tlt-green-row mt-3">
                    パスワード再設定メール送信
                </div>
                <div class="content-box mt-2 mb-4 p-4">
                    <p class="p-2">
                        パスワード再設定用のリンクを送信します。
                        ご登録されたメールアドレスを入力してください。
                    </p>
                    <div class="row-input row-input-auto-height p-4 mb-4">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">メールアドレス</div>
                            <input type="text" class="form-control mb-3">
                        </div>
                    </div>
                </div>
                <div class="text-center">
                    <button class="btn btn-common btn-big btn-bg-green">
                        送信
                    </button>
                </div>
                <!-- End màn 2 -->
            </div>
        
            <div class="wrapper-reponsive">
                <!-- Start màn 3 -->
                <div class="tlt-green-row mt-3">
                    パスワード再設定
                </div>
                <div class="content-box mt-2 mb-4 p-4">
                    <p class="p-2">
                        新規パスワードを入力してください。<br>
                        パスワードは以下の条件を満たす必要があります。<br>
                        ・8~16桁の半角英字、数字、記号<br>
                        ・英大文字、英小文字、数字または記号をそれぞれ1文字以上含む
                    </p>
                    <div class="row-input row-input-auto-height p-4 mb-4">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">新規パスワード </div>
                            <input type="text" class="form-control mb-3">
                            <div class="tlt-dot mb-1">新規パスワード（確認） </div>
                            <input type="text" class="form-control mb-3">
                        </div>
                    </div>
                </div>
                <div class="text-center">
                    <button class="btn btn-common btn-big btn-bg-green">
                        送信
                    </button>
                </div>
                <!-- End màn 3 -->
            </div>
        
            <div class="wrapper-reponsive">
                <!-- Start màn 4 -->
                <div class="tlt-green-row mt-3">
                    利用者情報入力
                </div>
                <div class="content-box mt-2 mb-4 p-4 scrollbar h640">
                    <p class="p-2">
                        利用者情報を入力してください。<br>
                        入力した情報は健診予約時に使用します。
                    </p>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">お名前 
                                <div class="mark-right">必須</div>
                            </div>
                            <input type="text" class="form-control">
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">フリガナ 
                                <div class="mark-right">必須</div>
                            </div>
                            <input type="text" placeholder="全角カナ" class="form-control">
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">生年月日 
                                <div class="mark-right">必須</div>
                            </div>
                            <input type="text" class="form-control">
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">性別 
                                <div class="mark-right">必須</div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-4">
                                    <label class="custom-radio">男
                                        <input type="radio" name="radio" id="1" checked>
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="col-4">
                                    <label class="custom-radio">女
                                        <input type="radio" name="radio" id="2" checked>
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">電話番号 
                                <div class="mark-right">必須</div>
                            </div>
                            <input type="text" class="form-control">
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">住所 
                                <div class="mark-right">必須</div>
                            </div>
                            <input type="text" class="form-control d-inline-block w200 mr-2">
                            <button class="btn-search-green mb-2">
                              <img src="../../../../../assets/img/icon_search.png" alt="">
                            </button>
                            <app-select-common>
                            </app-select-common>
                            <input type="text" class="form-control mt-2">
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">メールアドレス 
                            </div>
                            <p class="p-2">
                                example@hoge.co.jp
                            </p>
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">パスワード 
                                <div class="mark-right">必須</div>
                            </div>
                            <p class="p-2">
                                パスワードは以下の条件を満たす必要があります。<br>
                                ・8~16桁の半角英字、数字、記号<br>
                                ・英大文字、英小文字、数字または記号をそれぞれ1文字以上含む
                            </p>
                            <input type="text" class="form-control mb-2">
                            <input type="text" placeholder="確認のため再入力してください" class="form-control">
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">利用規約 
                                <div class="mark-right">必須</div>
                            </div>
                            <p class="p-2">
                                利用規約をご確認のうえ、ご登録ください。
                            </p>
                            <a href="#">
                                <strong>Smart TOHMAS 利用規約</strong>
                            </a>
                            <div class="mt-4">
                                <label class="custom-checkbox">
                                    利用規約に同意する
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center">
                    <button class="btn btn-common btn-big btn-bg-green">
                        送信
                    </button>
                </div>
                <!-- End màn 4 -->
            </div>
            
            <div class="wrapper-reponsive">
                <!-- Start màn 5 -->
                <div class="tlt-green-row mt-3">
                    トップページ
                </div>
                <div class="content-box mt-2 mb-4 p-4 scrollbar h640">
                    <div class="tlt-border mb-3">
                        予約・受診履歴
                    </div>
                    <div class="box-common bg-common-red mb-2">
                        <div class="tlt-dot dot-red m-0">
                            2021年5月11日 (火)　10:00 
                        </div>
                        <div class="p-3">
                            <div class="row">
                                <div class="col-6">
                                    <a href="#">
                                        <strong>○○健診センター</strong>
                                    </a>
                                </div>
                                <div class="col-6">
                                    <span>１日ドック　Aコース</span>
                                </div>
                            </div>
                            <div class="lst-button mt-3">
                                <button class="btn btn-bg-red">問診未入力あり</button>
                                <button class="btn btn-bg-yellow ml-3">予約確認・変更 </button>
                            </div>
                        </div>
                    </div>
                    <div class="box-common bg-common-red mb-2">
                        <div class="tlt-dot dot-red m-0">
                            2021年5月11日 (火)　10:00 
                        </div>
                        <div class="p-3">
                            <div class="row">
                                <div class="col-6">
                                    <a href="#">
                                        <strong>○○健診センター</strong>
                                    </a>
                                </div>
                                <div class="col-6">
                                    <span>１日ドック　Aコース</span>
                                </div>
                            </div>
                            <div class="lst-button mt-3">
                                <button class="btn">問診入力済</button>
                                <button class="btn btn-bg-yellow ml-3">予約確認・変更 </button>
                            </div>
                            <p class="mt-3">
                                ※予約変更可能期間を超過しました。変更やキャンセルを行う場合は、健診機関(<a href="#">03-0000-0000</a>)に直接お問い合わせいただくようお願い申し上げます。
                            </p>
                        </div>
                    </div>
                    <div class="box-common mb-2">
                        <div class="tlt-dot m-0">
                            2020年6月18日 (木)
                        </div>
                        <div class="p-3">
                            <div class="row">
                                <div class="col-6">
                                    <a href="#">
                                        <strong>○○健診センター</strong>
                                    </a>
                                </div>
                                <div class="col-6">
                                    <span>１日ドック　Aコース</span>
                                </div>
                            </div>
                            <div class="lst-button mt-3">
                                <button class="btn">健診結果確認</button>
                            </div>
                        </div>
                    </div>
                    <div class="box-common mb-2">
                        <div class="tlt-dot m-0">
                            2019年8月2日 (金)
                        </div>
                        <div class="p-3">
                            <div class="row">
                                <div class="col-6">
                                    <a href="#">
                                        <strong>○○健診センター</strong>
                                    </a>
                                </div>
                                <div class="col-6">
                                    <span>１日ドック　Aコース</span>
                                </div>
                            </div>
                            <div class="lst-button mt-3">
                                <button class="btn">健診結果確認</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End màn 5 -->
            </div>
            <div class="wrapper-reponsive">
                <!-- Start màn 6 -->
                <div class="tlt-green-row mt-3">
                    健診予約
                </div>
                <div class="content-box mt-2 mb-3 p-3">
                    <div class="process-step">
                        <p>Step</p>
                        <ul>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">1</span>
                                </div>
                            </li>
                            <li>
                                <div class="circle">
                                    <span class="num">2</span>
                                </div>
                            </li>
                            <li>
                                <div class="circle">
                                    <span class="num">3</span>
                                </div>
                            </li>
                            <li>
                                <div class="circle">
                                    <span class="num">4</span>
                                </div>
                            </li>
                            <li>
                                <div class="circle">
                                    <span class="num">5</span>
                                </div>
                            </li>
                            <li>
                                <div class="circle">
                                    <span class="num">6</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="content-box mt-2 mb-4 p-4 scrollbar h640">
                    <div class="tlt-border mb-3">
                    　　　予約区分選択
                    </div>
                    <p class="p-2">
                        ご希望の健診区分を選択してください。
                    </p>
                    <div class="text-center">
                        <div class="mb-4">
                            <button class="btn btn-common btn-bg-green">
                                健康保険を使った <br>
                                健診をご希望の方 
                            </button>
                        </div>
                        <div>
                            <button class="btn btn-common btn-bg-yellow">
                                自費での <br>
                                健診をご希望の方 
                            </button>
                        </div>
                        <!-- <div>
                            <button class="btn btn-common btn-bg-grey">
                                自費での <br>
                                健診をご希望の方 
                            </button>
                        </div> -->
                    </div>
                    <!-- <p class="p-2">
                        ※現在、健康保険を使った健診のみご予約可能です。
                    </p> -->
                </div>
                <!-- End màn 6 -->
            </div>
            <div class="wrapper-reponsive">
                <!-- Start màn 7 -->
                <div class="tlt-green-row mt-3">
                    健診予約
                </div>
                <div class="content-box mt-2 mb-3 p-3">
                    <div class="process-step">
                        <p>Step</p>
                        <ul>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">1</span>
                                </div>
                            </li>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">2</span>
                                </div>
                            </li>
                            <li>
                                <div class="circle">
                                    <span class="num">3</span>
                                </div>
                            </li>
                            <li>
                                <div class="circle">
                                    <span class="num">4</span>
                                </div>
                            </li>
                            <li>
                                <div class="circle">
                                    <span class="num">5</span>
                                </div>
                            </li>
                            <li>
                                <div class="circle">
                                    <span class="num">6</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="content-box mt-2 mb-4 p-4 scrollbar h640">
                    <div class="tlt-border mb-3">
                    　　　保険情報入力
                    </div>
                    <p class="p-2">
                        保険証に表記されている内容を入力してください。
                    </p>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">保険者番号 
                                <div class="mark-right">必須</div>
                            </div>
                            <input type="text" placeholder="全角カナ" class="form-control">
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">記号 
                                <div class="mark-right">必須</div>
                            </div>
                            <input type="text" placeholder="全角カナ" class="form-control">
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">番号 
                                <div class="mark-right">必須</div>
                            </div>
                            <input type="text" placeholder="全角カナ" class="form-control">
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">枝番 
                                <div class="mark-right">必須</div>
                            </div>
                            <p class="p-2">
                                保険証に枝番の表記がある方のみ、入力してください。
                            </p>
                            <input type="text" placeholder="全角カナ" class="form-control">
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">本人/家族 
                                <div class="mark-right">必須</div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-4">
                                    <label class="custom-radio">本人
                                        <input type="radio" name="radio" id="1" checked>
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="col-4">
                                    <label class="custom-radio">家族
                                        <input type="radio" name="radio" id="2" checked>
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box-common mb-2">
                        <div class="tlt-dot m-0">
                            社会保険(組合健保)の見本
                        </div>
                        <details>
                            <summary>
                                <div class="mark-carret"></div>
                            </summary>
                            <div></div>
                        </details>
                    </div>
                    <div class="box-common mb-2">
                        <div class="tlt-dot m-0">
                            社会保険(協会けんぽ)の見本
                        </div>
                        <details>
                            <summary>
                                <div class="mark-carret"></div>
                            </summary>
                            <div></div>
                        </details>
                    </div>
                    <div class="box-common mb-2">
                        <div class="tlt-dot m-0">
                            国民健康保険の見本
                        </div>
                        <details>
                            <summary>
                                <div class="mark-carret"></div>
                            </summary>
                            <div class="p-2 text-center">
                                <img src="../../../../assets/img/screen-7.jpg" alt="">
                            </div>
                        </details>
                    </div>
                </div>
                <div class="text-center">
                    <div class="mb-4">
                        <button class="btn btn-common btn-bg-green">
                            次へ 
                        </button>
                    </div>
                </div>
                <!-- End màn 7 -->
            </div>
        
            <div class="wrapper-reponsive">
                <!-- Start màn 8 -->
                <div class="tlt-green-row mt-3">
                    健診予約
                </div>
                <div class="content-box mt-2 mb-3 p-3">
                    <div class="process-step">
                        <p>Step</p>
                        <ul>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">1</span>
                                </div>
                            </li>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">2</span>
                                </div>
                            </li>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">3</span>
                                </div>
                            </li>
                            <li>
                                <div class="circle">
                                    <span class="num">4</span>
                                </div>
                            </li>
                            <li>
                                <div class="circle">
                                    <span class="num">5</span>
                                </div>
                            </li>
                            <li>
                                <div class="circle">
                                    <span class="num">6</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="content-box mt-2 mb-4 p-4 scrollbar h640">
                    <div class="tlt-border mb-3">
                        受診者情報入力
                    </div>
                    <p class="p-2">
                        受診者情報を入力してください。
                    </p>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">お名前 
                                <div class="mark-right">必須</div>
                            </div>
                            <input type="text" class="form-control">
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">フリガナ 
                                <div class="mark-right">必須</div>
                            </div>
                            <input type="text" placeholder="全角カナ" class="form-control">
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">生年月日 
                                <div class="mark-right">必須</div>
                            </div>
                            <input type="text" class="form-control">
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">性別 
                                <div class="mark-right">必須</div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-4">
                                    <label class="custom-radio">男
                                        <input type="radio" name="radio" id="1" checked>
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="col-4">
                                    <label class="custom-radio">女
                                        <input type="radio" name="radio" id="2" checked>
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">電話番号 
                                <div class="mark-right">必須</div>
                            </div>
                            <input type="text" class="form-control">
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">住所 
                                <div class="mark-right">必須</div>
                            </div>
                            <input type="text" class="form-control d-inline-block w200 mr-2">
                            <button class="btn-search-green mb-2">
                              <img src="../../../../../assets/img/icon_search.png" alt="">
                            </button>
                            <app-select-common>
                            </app-select-common>
                            <input type="text" class="form-control mt-2">
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">メールアドレス 
                            </div>
                            <p class="p-2">
                                example@hoge.co.jp
                            </p>
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">ご要望・特記事項
                            </div>
                            <p class="p-2">
                                何か健診機関にお伝えしたい情報やご要望、特記事項がある場合は入力してください。
                            </p>
                            <textarea name="" class="form-control" id="" rows="3"></textarea>
                        </div>
                    </div>
                </div>
                <div class="text-center">
                    <button class="btn btn-common btn-big btn-bg-green">
                        次へ
                    </button>
                </div>
                <!-- End màn 8 -->
            </div>

            <div class="wrapper-reponsive">
                <!-- Start màn 9 -->
                <div class="tlt-green-row mt-3">
                    健診予約
                </div>
                <div class="content-box mt-2 mb-3 p-3">
                    <div class="process-step">
                        <p>Step</p>
                        <ul>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">1</span>
                                </div>
                            </li>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">2</span>
                                </div>
                            </li>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">3</span>
                                </div>
                            </li>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">4</span>
                                </div>
                            </li>
                            <li>
                                <div class="circle">
                                    <span class="num">5</span>
                                </div>
                            </li>
                            <li>
                                <div class="circle">
                                    <span class="num">6</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="content-box mt-2 mb-4 p-4 scrollbar h640">
                    <div class="tlt-border mb-3">
                        健診コース・オプション選択
                    </div>
                    <p class="p-2">
                        受診を希望するコース、追加検査を希望するオプションを選択してください。<br>
                        <br>
                        ※表示されている金額は全て税込価格です。
                    </p>
                    <div class="box-common mb-2">
                        <div class="tlt-dot m-0">
                            健診コース
                            <div class="mark-right">必須</div>
                        </div>
                        <div class="table-common">
                            <table class="table table-bordered table-striped">
                                <caption class="d-none"></caption>
                                <thead class="d-none">
                                    <tr>
                                        <th style="width:70%"></th>
                                        <th style="width:30%"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <label class="custom-radio">
                                                2021/04/01 – 2022/03/31 <br>
                                                定期健診Aコース
                                                <input type="radio" name="radio">
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td class="text-right">
                                            3,000円
                                        </td>
                                    </tr>
                                    <tr class="active">
                                        <td>
                                            <label class="custom-radio">
                                                2021/04/01 – 2022/03/31<br>
                                            　　定期健診Bコース
                                                <input type="radio" name="radio">
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td class="text-right">
                                            5,000円
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label class="custom-radio">
                                                2021/04/01 – 2022/03/31<br>
                                                定期健診Cコース
                                                <input type="radio" name="radio">
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td class="text-right">
                                            10,000円
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="box-common bg-common-red mb-2">
                        <div class="tlt-dot dot-red m-0">
                            オプション
                        </div>
                        <div class="form-row-2">
                            <div class="col-item">
                                <label class="custom-checkbox">
                                    肺がん検診 <br>
                                    　　1,000円 
                                    <input type="checkbox" checked="checked" >
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-item">
                                <label class="custom-checkbox">
                                    大腸がん検診 <br>
                                　　1,000円 
                                    <input type="checkbox" checked="checked" >
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-item active">
                                <label class="custom-checkbox">
                                    胃がん検診 <br>
                                    　　3,000円 
                                    <input type="checkbox" checked="checked" >
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-item">
                                <label class="custom-checkbox">
                                    子宮がん検診 <br>
　　                                500円 
                                    <input type="checkbox" checked="checked" >
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="box-common bg-common-red mb-2">
                        <div class="tlt-dot dot-red m-0">
                            健診機関オプション
                            <p>
                                健診機関が用意した任意で受診できる <br>
                        　　   自己負担制のオプションです。
                            </p>
                        </div>
                        <div class="form-row-2">
                            <div class="col-item">
                                <label class="custom-checkbox">
                                    脳ドッグ <br>
　　                                58,000円 
                                    <input type="checkbox" checked="checked" >
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-item">
                                <label class="custom-checkbox">
                                    脳MRI <br>
　　                                36,000円 
                                    <input type="checkbox" checked="checked" >
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-item active">
                                <label class="custom-checkbox">
                                    レディースドッグ <br>
　　                                35,000円 
                                    <input type="checkbox" checked="checked" >
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-item">
                                <label class="custom-checkbox">
                                    大腸ドッグ <br>
　　                                32,500円 
                                    <input type="checkbox" checked="checked" >
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="box-common d-flex mb-2">
                        <div class="tlt-dot w-50 m-0 pr-4">
                            合計金額
                        </div>
                        <div class="d-flex w-50 justify-content-center align-items-center fz-24">
                            <strong>43,000円</strong>
                        </div>
                    </div>
                    <p class="p-2" style="background-color: #FFF2CC;">
                        ※企業または健保組合が負担する上限額を超過した料金(13,000円)が加算されています。
                    </p>
                </div>
                <div class="text-center">
                    <button class="btn btn-common btn-big btn-bg-green">
                        次へ
                    </button>
                </div>
                <!-- End màn 9 -->
            </div>

            <div class="wrapper-reponsive">
                <!-- Start màn 10 -->
                <div class="tlt-green-row mt-3">
                    健診予約
                </div>
                <div class="content-box mt-2 mb-3 p-3">
                    <div class="process-step">
                        <p>Step</p>
                        <ul>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">1</span>
                                </div>
                            </li>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">2</span>
                                </div>
                            </li>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">3</span>
                                </div>
                            </li>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">4</span>
                                </div>
                            </li>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">5</span>
                                </div>
                            </li>
                            <li>
                                <div class="circle">
                                    <span class="num">6</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="content-box mt-2 mb-4 p-4 scrollbar h640">
                    <div class="tlt-border mb-3">
                        予約日時選択
                    </div>
                    <p class="p-2">
                        受診を希望するコース、追加検査を希望するオプションを選択してください。<br>
                        <br>
                        ※表示されている金額は全て税込価格です。
                    </p>
                    <div class="box-common mb-2">
                        <div class="tlt-dot m-0">
                            予約日
                            <div class="mark-right">必須</div>
                            <p class="pb-1">以下のカレンダーから受診希望日を選択してください。</p>
                        </div>
                        <p class="p-3">
                            <span>
                                <span style="color: #1DCD80;">●</span>：空き枠あり
                            </span>
                            <span>×：空き枠なし</span>
                            <span>グレー：非営業日</span>
                        </p>
                    </div>
                    <div class="box-common mb-2">
                        <div class="tlt-dot m-0">
                            予約時間
                            <div class="mark-right">必須</div>
                            <p class="pb-2">
                                予約可能な受付時間が表示されます。 <br>
                                希望する時間を選択してください。
                            </p>
                        </div>
                        <div class="form-row-2">
                            <div class="col-item">
                                <label class="custom-radio">
                                    09 : 00
                                    <input type="radio" name="radio">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-item">
                                <label class="custom-radio">
                                    10 : 00
                                    <input type="radio" name="radio">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-item active">
                                <label class="custom-radio">
                                    13 : 00
                                    <input type="radio" name="radio" checked>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-item">
                                <label class="custom-radio">
                                    14 : 00
                                    <input type="radio" name="radio">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center">
                    <button class="btn btn-common btn-big btn-bg-green">
                        次へ
                    </button>
                </div>
                <!-- End màn 10 -->
            </div>

            <div class="wrapper-reponsive">
                <!-- Start màn 11 -->
                <div class="tlt-green-row mt-3">
                    健診予約
                </div>
                <div class="content-box mt-2 mb-3 p-3">
                    <div class="process-step">
                        <p>Step</p>
                        <ul>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">1</span>
                                </div>
                            </li>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">2</span>
                                </div>
                            </li>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">3</span>
                                </div>
                            </li>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">4</span>
                                </div>
                            </li>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">5</span>
                                </div>
                            </li>
                            <li class="active">
                                <div class="circle">
                                    <span class="num">6</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="content-box mt-2 mb-4 p-4 scrollbar h640">
                    <div class="tlt-border mb-3">
                        予約内容確認
                    </div>
                    <p class="p-2">
                        予約内容をご確認ください。 <br>
                        誤りがある場合は内容修正から修正可能です。<br>
                        <br>
                        ※表示されている金額は全て税込価格です。
                    </p>
                    <div class="box-common mb-2">
                        <div class="tlt-dot m-0">
                            予約日
                            <div class="mark-right green">内容修正</div>
                        </div>
                        <ul class="lst-item-border">
                            <li>
                               <p class="tlt"> 【予約日】 </p>
                               <div class="desc">
                                   <span> 2021年9月9日 (木)</span>
                               </div>
                            </li>
                            <li>
                                <p class="tlt">【予約時間】</p>
                                <div class="desc">
                                    <span> 13 : 00</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="box-common mb-2">
                        <div class="tlt-dot m-0">
                            健診コース・オプション
                            <div class="mark-right green">内容修正</div>
                        </div>
                        <ul class="lst-item-border">
                            <li>
                                <p class="tlt"> 【健診コース】 </p>
                               <div class="desc">
                                   <span>定期健診Aコース</span>
                                   <span>5,000円</span>
                               </div>
                            </li>
                            <li>
                                <p class="tlt"> 【オプション】 </p>
                               <div class="desc">
                                   <span>胃がん健診</span>
                                   <span>3,000円</span>
                               </div>
                               <div class="desc">
                                   <span>レディースドック</span>
                                   <span>35,000円</span>
                               </div>
                            </li>
                            <li>
                                <p class="tlt">  【合計金額】 </p>
                               <div class="desc">
                                   <span></span>
                                   <span>43,000円</span>
                               </div>
                            </li>
                        </ul>
                    </div>
                    <div class="box-common mb-2">
                        <div class="tlt-dot m-0">
                            受診者情報
                            <div class="mark-right green">内容修正</div>
                        </div>
                        <ul class="lst-item-border">
                            <li>
                                <p class="tlt">【お名前】 </p>
                               <div class="desc">
                                   <span>あいうえ　おかき</span>
                               </div>
                            </li>
                            <li>
                                <p class="tlt">【フリガナ】 </p>
                               <div class="desc">
                                   <span>アイウエ　オカキ</span>
                               </div>
                            </li>
                            <li>
                                <p class="tlt">【生年月日】</p>
                               <div class="desc">
                                   <span>1960年5月12日</span>
                               </div>
                               <div class="desc">
                                   <span>〒123-4567</span>
                               </div>
                               <div class="desc">
                                   <span>○○県○○市～</span>
                               </div>
                            </li>
                            <li>
                                <p class="tlt">【メールアドレス】</p>
                               <div class="desc">
                                   <span>～＠hoge.co.jp</span>
                               </div>
                            </li>
                            <li>
                                <p class="tlt">【ご要望・特記事項】</p>
                               <div class="desc">
                                   <span>あいうえを</span>
                               </div>
                            </li>
                        </ul>
                    </div>
                    <div class="box-common mb-2">
                        <div class="tlt-dot m-0">
                            保険情報
                            <div class="mark-right green">内容修正</div>
                        </div>
                        <ul class="lst-item-border">
                            <li>
                                <p class="tlt">【保険者番号】 </p>
                               <div class="desc">
                                   <span>12345678</span>
                               </div>
                            </li>
                            <li>
                                <p class="tlt">【記号】</p>
                               <div class="desc">
                                   <span>1234567890</span>
                               </div>
                            </li>
                            <li>
                                <p class="tlt">【番号】</p>
                               <div class="desc">
                                   <span>1234567890</span>
                               </div>
                            </li>
                            <li>
                                <p class="tlt">【枝番】</p>
                               <div class="desc">
                                   <span>1</span>
                               </div>
                            </li>
                            <li>
                                <p class="tlt">【本人/家族】</p>
                               <div class="desc">
                                   <span>本人</span>
                               </div>
                            </li>
                        </ul>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot mb-1">健診Web予約規約 
                                <div class="mark-right">必須</div>
                            </div>
                            <p class="p-2">
                                健診Web予約規約をご確認のうえ、ご登録ください。
                            </p>
                            <a href="#">
                                <strong>Smart TOHMAS 健診Web予約規約</strong>
                            </a>
                            <div class="mt-4">
                                <label class="custom-checkbox">
                                    健診Web予約規約に同意する
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center">
                    <div class="mb-3">
                        <button class="btn btn-common btn-big btn-bg-green">
                            予約登録 
                        </button>
                    </div>
                    <div class="mb-3">
                        <button class="btn btn-common btn-big btn-bg-red">
                            予約キャンセル 
                        </button>
                    </div>
                    <div class="mb-3">
                        <button class="btn btn-common btn-big btn-bg-yellow">
                            戻る 
                        </button>
                    </div>
                </div>
                <!-- End màn 11 -->
            </div>
            
            <div class="wrapper-reponsive">
                <!-- Start màn 12 -->
                <div class="nav-tab-common">
                    <ul>
                        <li class="active">
                            <a href="">健診予約</a>
                        </li>
                        <li>
                            <a href="">健診予約</a>
                        </li>
                    </ul>
                </div>
                <div class="tlt-green-row mt-3">
                    健診予約
                </div>
                <div class="content-box mt-2 mb-4 p-4 scrollbar h640">
                    <div class="tlt-border mb-3">
                        予約内容確認
                    </div>
                    <p class="p-2">
                        予約内容をご確認ください。
                    </p>
                    <div class="row-input row-input-auto-height p-3 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot">
                                予約日
                            </div>
                            <div class="row mt-2">
                                <div class="col-4">
                                    <label class="custom-radio">男
                                        <input type="radio" name="radio" id="1" checked>
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="col-4">
                                    <label class="custom-radio">女
                                        <input type="radio" name="radio" id="2" checked>
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-3 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot">
                                予約日
                            </div>
                            <p class="p-2 m-0">
                                予約内容をご確認ください。
                            </p>
                            <div class="mt-2">
                                <label class="custom-radio">男
                                    <input type="radio" name="radio" id="1" checked>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="mt-2">
                                <label class="custom-radio">男
                                    <input type="radio" name="radio" id="1" checked>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="mt-2">
                                <label class="custom-radio">男
                                    <input type="radio" name="radio" id="1" checked>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-3 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot">
                                健診コース・オプション
                            </div>
                            <div class="row mt-3">
                                <div class="col-6 pr-0">
                                    <input type="text" class="form-control">
                                </div>
                                <div class="col-6">
                                    修/正
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-box mt-2 mb-4 p-4 scrollbar h640">
                    <div class="tlt-border mb-3">
                        予約内容確認
                    </div>
                    <p class="p-2">
                        予約内容をご確認ください。
                    </p>
                    <div class="row-input row-input-auto-height p-3 mb-2">
                        <div class="pb-3" style="border-bottom: 1px solid #ccc">
                            <label class="custom-checkbox">
                                利用規約
                                <input type="checkbox">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="row">
                            <div class="col-6 pt-3">
                                <label class="custom-checkbox">
                                    利用規約
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-6 pt-3">
                                <label class="custom-checkbox">
                                    利用規約
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-6 pt-3">
                                <label class="custom-checkbox">
                                    利用規約
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-6 pt-3">
                                <label class="custom-checkbox">
                                    利用規約
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot">
                                健診コース・オプション
                            </div>
                            <div class="pt-3">
                                <input type="text" class="form-control">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-box mt-2 mb-4 p-4 scrollbar h640">
                    <div class="tlt-border mb-3">
                        予約内容確認
                    </div>
                    <p class="p-2">
                        予約内容をご確認ください。
                    </p>
                    <div class="row-input row-input-auto-height p-3 mb-2">
                        <div class="pb-3" style="border-bottom: 1px solid #ccc">
                            <label class="custom-checkbox">
                                利用規約
                                <input type="checkbox">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="table-radio">
                            <table>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th class="text-center">用規約</th>
                                        <th class="text-center">用規</th>
                                        <th class="text-center">用規</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>用規約</td>
                                        <td class="text-center">
                                            <label class="custom-radio">
                                                <input type="radio" name="radio" id="1" checked>
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td class="text-center">
                                            <label class="custom-radio">
                                                <input type="radio" name="radio" id="1" checked>
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td class="text-center">
                                            <label class="custom-radio">
                                                <input type="radio" name="radio" id="1" checked>
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>用規約</td>
                                        <td class="text-center">
                                            <label class="custom-radio">
                                                <input type="radio" name="radio" id="1" checked>
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td class="text-center">
                                            <label class="custom-radio">
                                                <input type="radio" name="radio" id="1" checked>
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td class="text-center">
                                            <label class="custom-radio">
                                                <input type="radio" name="radio" id="1" checked>
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>用規約規約</td>
                                        <td class="text-center">
                                            <label class="custom-radio">
                                                <input type="radio" name="radio" id="1" checked>
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td class="text-center">
                                            <label class="custom-radio">
                                                <input type="radio" name="radio" id="1" checked>
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                        <td class="text-center">
                                            <label class="custom-radio">
                                                <input type="radio" name="radio" id="1" checked>
                                                <span class="checkmark"></span>
                                            </label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row-input row-input-auto-height p-4 mb-2">
                        <div class="pl-3">
                            <div class="tlt-dot">
                                健診コース・オプション
                            </div>
                            <div class="pt-3">
                                <input type="text" class="form-control">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-box mt-2 mb-4 p-4 scrollbar h640">
                    <div class="tlt-border mb-3">
                        予約内容確認
                    </div>
                    <div class="mt-3">
                        <textarea name="" id="" rows="5" placeholder="健診予約健診予約健診予約健診予約" class="form-control"></textarea>
                    </div>
                </div>
                <div class="text-center">
                    <div class="mb-3">
                        <button class="btn btn-common btn-big btn-bg-green">
                            予約
                        </button>
                    </div>
                </div>
                <div class="fixed-action">
                    <button class="btn-circle-action">
                        登録
                    </button>
                </div>
                <!-- End màn 12 -->
            </div>

            <div class="wrapper-reponsive">
                <!-- Start màn 13 -->
                
                <!-- Modal -->
                <div class="modal-content">
                    <div class="modal-header">
                    <h5 class="modal-title">企業団体選択</h5>
                    <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button> -->
                    </div>
                    <div class="modal-body">
                        <p>
                            所属する企業団体を選択してください。<br>
                            所属する企業団体が表示されない場合は、保険情報の入力に誤りがないかご確認のうえ、健診機関にお問い合わせください。
                        </p>
                        <div class="box-common m-4">
                            <div class="tlt-dot m-0">
                                健診コース
                            </div>
                            <div class="table-common">
                                <table class="table table-bordered table-striped">
                                    <caption class="d-none"></caption>
                                    <thead class="d-none">
                                        <tr>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <label class="custom-radio">
                                                    2021/04/01 – 2022/03/31 <br>
                                                    定期健診Aコース
                                                    <input type="radio" name="radio">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </td>
                                        </tr>
                                        <tr class="active">
                                            <td>
                                                <label class="custom-radio">
                                                    2021/04/01 – 2022/03/31<br>
                                                　　定期健診Bコース
                                                    <input type="radio" name="radio">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label class="custom-radio">
                                                    2021/04/01 – 2022/03/31<br>
                                                    定期健診Cコース
                                                    <input type="radio" name="radio">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="text-right">
                            <button class="btn btn-common w150 btn-bg-red">
                                キャンセル
                            </button>
                            <button class="btn btn-common w150 btn-bg-green ml-3">
                                選択
                            </button>
                        </div>
                    </div>
                </div>
                <!-- End màn 13 -->
            </div>


        </div>
    </div>
    <div class="content-footer">
        <span>COPYRIGHT © ITEC HANKYU HANSHIN CO.,LTD.</span>
    </div>
</div>